<template>
  <transition name="task-notification-slide">
    <div v-if="visible" class="task-notification" @mouseenter="pause" @mouseleave="resume">
      <div class="task-notification__accent" :style="{ backgroundColor: accentColor }"></div>
      <div class="task-notification__body">
        <div class="task-notification__icon" :style="{ backgroundColor: iconBgColor }">
          <v-icon size="20" :color="accentColor">{{ icon }}</v-icon>
        </div>
        <div class="task-notification__content">
          <span class="task-notification__title">{{ title }}</span>
          <span v-if="text" class="task-notification__text">{{ text }}</span>
        </div>
        <button class="task-notification__close" @click="close">
          <v-icon size="18" color="#90a4ae">close</v-icon>
        </button>
      </div>
      <div class="task-notification__footer">
        <button class="task-notification__link" :style="{ color: accentColor }" @click="openTasks">
          {{ $t('wkt.admin.tasks.messages.realtime_open_tasks') }}
        </button>
      </div>
      <div class="task-notification__progress">
        <div
          class="task-notification__progress-bar"
          :style="{ width: progressWidth + '%', backgroundColor: accentColor }"
        ></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TaskNotification',
  props: {
    timeout: {
      type: Number,
      default: 8000
    }
  },
  data() {
    return {
      visible: false,
      title: '',
      text: '',
      eventType: null,
      progressWidth: 100,
      intervalId: null,
      startTime: null,
      remaining: 0,
      paused: false
    };
  },
  computed: {
    accentColor() {
      const colors = {
        CREATED: '#185EA9',
        ASSIGNED: '#185EA9',
        UNASSIGNED: '#78909C',
        COMMENT_ADDED: '#00838F',
        STATUS_CHANGED: '#6A3DB8',
        UPDATED: '#185EA9',
        TASK_BECAME_VISIBLE: '#4caf50',
        REMINDER_TRIGGERED: '#F57C00',
      };
      return (this.eventType && colors[this.eventType]) ? colors[this.eventType] : '#185EA9';
    },
    iconBgColor() {
      const colors = {
        CREATED: '#E8F0F9',
        ASSIGNED: '#E8F0F9',
        UNASSIGNED: '#ECEFF1',
        COMMENT_ADDED: '#E0F5F7',
        STATUS_CHANGED: '#F0EAFA',
        UPDATED: '#E8F0F9',
        TASK_BECAME_VISIBLE: '#E8F5E9',
        REMINDER_TRIGGERED: '#FFF3E0',
      };
      return (this.eventType && colors[this.eventType]) ? colors[this.eventType] : '#E8F0F9';
    },
    icon() {
      const icons = {
        CREATED: 'add_task',
        ASSIGNED: 'person_add',
        UNASSIGNED: 'person_remove',
        COMMENT_ADDED: 'chat_bubble',
        STATUS_CHANGED: 'swap_horiz',
        UPDATED: 'edit',
        TASK_BECAME_VISIBLE: 'visibility',
        REMINDER_TRIGGERED: 'notifications_active',
      };
      return (this.eventType && icons[this.eventType]) ? icons[this.eventType] : 'task_alt';
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    show({ title, text, eventType }) {
      this.clearTimer();
      this.title = title || '';
      this.text = text || '';
      this.eventType = eventType || null;
      this.progressWidth = 100;
      this.remaining = this.timeout;
      this.paused = false;
      this.visible = true;
      this.startCountdown();
    },
    close() {
      this.clearTimer();
      this.visible = false;
    },
    pause() {
      this.paused = true;
      this.clearTimer();
    },
    resume() {
      this.paused = false;
      this.startCountdown();
    },
    startCountdown() {
      this.startTime = Date.now();
      const step = 30;
      this.intervalId = setInterval(() => {
        if (this.paused) return;
        const elapsed = Date.now() - this.startTime;
        this.remaining = Math.max(0, this.remaining - elapsed);
        this.startTime = Date.now();
        this.progressWidth = (this.remaining / this.timeout) * 100;
        if (this.remaining <= 0) {
          this.close();
        }
      }, step);
    },
    clearTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    openTasks() {
      this.close();
      window.location.hash = '#em;id=208';
    }
  }
};
</script>
